import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
@Pipe({
    name: 'timeFormat',
    standalone: false
})
export class TimeFormatPipe implements PipeTransform {
    
    transform(value:any): any {
        if (value != undefined) {
          return value= moment(value).format('hh:mm A');
        }
    }
}